import { notification } from 'antd'
import { AxiosError } from 'axios'

import { parseErrorsToString } from 'Shared/utils'

import { TIMEOUT_ERROR_CODE } from 'Core/constants'
import { AxiosErrorResponse, NotificationProps } from 'Core/interfaces'

import styles from 'Shared/atoms/Notifications/styles.module.scss'

/**
 * Singleton service for showing UI toast notifications.
 *
 * Use this directly in stores instead of accessing `rootStore[STORE_UI]`:
 *
 *   import notificationService from 'Core/services/NotificationService'
 *   notificationService.showErrorNotification(error)
 *
 * UIStore delegates its notification methods here so that both calling patterns
 * remain fully compatible during the incremental migration.
 */
class NotificationService {
	showNotification = ({ type = 'info', msg }: NotificationProps) => {
		notification[type]({
			message: msg,
			className: styles.notification,
			placement: 'top'
		})
	}

	showSuccessNotification = (message: string) =>
		this.showNotification({ type: 'success', msg: message })

	showErrorNotification = (error?: AxiosError, msg?: string) => {
		const data = error?.response?.data as AxiosErrorResponse
		const parsedMsg = parseErrorsToString(data?.errors, msg)
		this.showNotification({
			type: 'error',
			msg: error?.code === TIMEOUT_ERROR_CODE ? error.message : parsedMsg
		})
	}
}

const notificationService = new NotificationService()

export { NotificationService }
export default notificationService
